import React, { useCallback, useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { getlandingpages } from '../../../API/PhishingAPI';
import TemplateGallery from '../TemplateGallery/TemplateGallery';

export default function TemplateImportPicker({ onBlank, onClose, onImported, onCombine, primaryActionLabel, t }) {
  const [pages, setPages] = useState(null), [error, setError] = useState(false), [revision, setRevision] = useState(0);
  const retry = useCallback(() => setRevision(value => value + 1), []);
  useEffect(() => {
    let active = true;
    setError(false);
    getlandingpages({ domain: '0.template' }).then(items => { if (active) setPages(items); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [revision]);
  return <Modal isOpen toggle={onClose} size="xl" scrollable className="simulation-template-library-modal"
    labelledBy="campaign-template-library-title">
    <ModalHeader toggle={onClose}><span id="campaign-template-library-title">{t('template_gallery.create_set')}</span></ModalHeader>
    <ModalBody className="simulation-wizard__library">
      <div className="simulation-wizard__library-actions">
        <p>{t('simulation_wizard.create_template_help')}</p>
        {onCombine && <Button color="light" onClick={onCombine}>{t('template_gallery.combine_existing')}</Button>}
        <Button color="primary" onClick={onBlank}>+ {t('simulation_wizard.start_blank')}</Button>
      </div>
      <TemplateGallery kind="page" items={pages} error={error} loading={!pages && !error} onRetry={retry} onImported={onImported}
        primaryActionLabel={primaryActionLabel || t('simulation_wizard.import_use')} />
    </ModalBody>
    <ModalFooter><Button color="link" onClick={onClose}>{t('template_gallery.cancel')}</Button></ModalFooter>
  </Modal>;
}
